import router from "./router";
import store from "./store";
import { getAccessToken, setAccessToken, setRefreshToken } from "@/utils/auth";

let HOST = process.env.HOST;
let redirectUrl = "";
let URL = "";
switch (HOST) {
  case "dev":
    redirectUrl = "http://weixiao.ct-study.com.cn";
    URL = "http%3A%2F%2Fweixiao.ct-study.com.cn";
    break;
  case "prod":
    redirectUrl = "https://feedback.sjtu.edu.cn";
    URL = "https%3A%2F%2Ffeedback.sjtu.edu.cn";
    break;
  case "test":
    redirectUrl = "http://weixiao.ct-study.com.cn";
    URL = "http%3A%2F%2Fweixiao.ct-study.com.cn";
    break;
  // http://localhost:80
  // http://weixiao.ct-study.com.cn
}
const allAllow = true;
const whiteList = ["114.84.255.98"];

router.beforeEach((to, from, next) => {
  // setAccessToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjNkMzdmMTM3NDRmZDBkYmVjNzQzYzUwZTljNmI0OGZmOWE3MWYwYWRlYzdjZGUzZGRiNDg3MmJmYjM1YzU2ZWMzOTBjMjUxOWVlN2M0MjI1In0.eyJhdWQiOiIyIiwianRpIjoiM2QzN2YxMzc0NGZkMGRiZWM3NDNjNTBlOWM2YjQ4ZmY5YTcxZjBhZGVjN2NkZTNkZGI0ODcyYmZiMzVjNTZlYzM5MGMyNTE5ZWU3YzQyMjUiLCJpYXQiOjE2Njc5NjgyNjIsIm5iZiI6MTY2Nzk2ODI2MiwiZXhwIjoxNjY4NTczMDYyLCJzdWIiOiI1Iiwic2NvcGVzIjpbIioiXX0.VabqYq1mkFbkj1lHWv8RV-Ev9VO6svYwqmzyPU5rhbnN5PjoL8oj-MDq_eX2LhjnqU8wvOpCcNtxcNjne13RF4smW9jWVuhqauCWF4HUmRYdXnRyssL9mUcB4m6aui3KP9H4XykltBL8ofOIjJV1cWx2byRb0G31OrUtTBviRjP11mABItTxVREwq2-qHz0UUM5dNLO8qKcE4IkA5axMazesKeT79-1_zzpjM2NcEXl44QCoJaMaEU291nDEWxmfGzcZi6rRwDhFxBNNyz_Hzm12JjSIFTjK093JL3KUUieX4xoOx7cLgvAy7O-oSGTMgtOqswkGh-OzNAHmubnuPM6w_W9Z9DDJj8OUrlq_cFyDe6QNmDjrfqPEg8rRJDFZnLmrC4DWE6308cUutxK_H1VaO-2sWWay24LQUABYXtXFNUMciwRfqhL6deIwHYDdJpCvg6NRcc4MowbVCTnZnFqAsTM8Kb-Yeb7pRYUQsCO7oCnNdSloJL4ueFXqnYpuOCHO4PFUSsuZpwiAgt4HxlLkBjZCQos87Q_tBs_UhuF3T5pHeoIK-HZWaqSQOjtXgWxkE_tIlkCtNSdl4gVL6AhWPjn2yCOP9ZZtv0hC43c7B3tq1A1XLIT3pytwxL9tV91KxPDMDq-JlcoI2shwXxAwJScjAmJxE6GdOGUIlF8')
  if (allAllow || whiteList.indexOf(returnCitySN["cip"]) > -1) {
    if (
      (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ||
        /(Android)/i.test(navigator.userAgent)) &&
      to.name != "ShowData"
    ) {
      if (window.location.pathname == "/BulletinArticle") {
        window.location.href =
          window.$phoneHtml + "/Article" + window.location.search;
      } else {
        window.location.href =
          window.$phoneHtml + window.location.pathname + window.location.search;
      }
    } else {
      if (
        to.name == "Home" ||
        to.name == "ShowData" ||
        to.name == "ServicePublic" ||
        to.name == "ServiceDetail" ||
        to.name == "TeamList" ||
        to.name == "DataPublic" ||
        to.name == "Online" ||
        to.name == "BulletinArticle" ||
        to.name == "Bulletin" ||
        to.name == "Dean" ||
        getAccessToken()
      ) {
        if (to.query.code) {
          store
            .dispatch("login", { code: to.query.code, url: redirectUrl })
            .then(res => {
              setAccessToken(res.access_token);
              next({ path: store.getters.nowPath, replace: true });
            });
        } else {
          next();
        }
      } else {
        if (to.query.code) {
          store
            .dispatch("login", { code: to.query.code, url: redirectUrl })
            .then(res => {
              setAccessToken(res.access_token);
              next({ path: store.getters.nowPath, replace: true });
            });
        } else {
          store.dispatch("commitNowPath", to.fullPath).then(() => {
            window.location.href =
              "https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=essential&client_id=N7WGL0JVqs3IiSJGdP4A&redirect_uri=" +
              URL;
          });
        }
      }
    }
  } else {
    if (to.name == "Building") next();
    else next({ path: "/Building", replace: true });
    // if(to.name == 'Dean') next()
    // else next({path:'/Dean', replace: true})
  }
});

router.afterEach(() => {});

// WEBPACK FOOTER //
// ./src/permission.js



// WEBPACK FOOTER //
// ./src/permission.js